<ng-container
  *ngIf="
    (reducedCooling$ | async | ready) ||
    (normalCooling$ | async | ready) ||
    (comfortCooling$ | async | ready)
  "
>
  <div class="flex flex-col gap-[10px] justify-start items-start">
    <div class="flex flex-row">
      <vi-title asThirdTitle="true">{{
        '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.COOLING_SELECTORS.TITLE' | translate
      }}</vi-title>
    </div>
    <div data-at-cooling-programs class="programs w-full min-w-full h-full min-h-full">
      <ng-container *ngIf="reducedCooling$ | async | ready as feature">
        <app-temperature-select
          *ngIf="feature | executable: 'setTemperature'"
          [isTile]="true"
          id="cooling-reduced-mode-select-{{ feature.feature | modeName }}"
          [title]="feature.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
          [value]="feature?.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
        >
        </app-temperature-select>
      </ng-container>
      <ng-container *ngIf="normalCooling$ | async | ready as feature">
        <app-temperature-select
          *ngIf="feature | executable: 'setTemperature'"
          [isTile]="true"
          id="cooling-normal-mode-select-{{ feature.feature | modeName }}"
          [title]="feature.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
          [value]="feature?.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
        >
        </app-temperature-select>
      </ng-container>
      <ng-container *ngIf="comfortCooling$ | async | ready as feature">
        <app-temperature-select
          *ngIf="feature | executable: 'setTemperature'"
          [isTile]="true"
          id="cooling-comfort-mode-select-{{ feature.feature | modeName }}"
          [title]="feature.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
          [value]="feature?.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
        >
        </app-temperature-select>
      </ng-container>
    </div>
  </div>
</ng-container>
